import { useSelector } from 'react-redux'
import useDate from '../../hooks/app/useDate'

const FormatDate = ({ pattern = 'dd/MMM/yyyy', date }) => {
  const { formatDate } = useDate()
  const currentDate = useSelector(state => state?.date?.date || new Date())

  if (!date) {
    return formatDate(currentDate, pattern) 
  }

  return formatDate(date, pattern) 
}

export default FormatDate